import React from "react";
import { BenefitGrid } from "../../../../types/enrollmentV2.types";
import {
	COREBenefitThumbnailMap,
	COREPFBBenefitThumbnailMap,
	VEBBenefitThumbnailMap
} from "../../../../constants/cartContents";
import CoreVebCard from "../corevebCardV2.tsx/CoreVebCardV2";
import { PFBDentalPlanImage, PFBVisionPlanImage } from "../../../../assets";
import { CorePanhandlePlansName } from "../../../../constants/plan";
import { GROUP_NUMBER } from "../../../../constants/groups";

const renderCard = (
	data: BenefitGrid,
	index: number,
	isVEB: boolean,
	coreBenefits: BenefitGrid[],
	vebBenefits: BenefitGrid[],
	coreTrueCount?: any,
	vebTrueCount?: any,
	coreDependents?: any,
	vebDependents?: any,
	vebRiderCount?: any,
	vebRiders?: any
) => {
	const {
		plan_name,
		base_plan_name,
		sub_plan,
		total_premium,
		effective_date,
		benefit_end_date,
		termination_date,
		plan_code,
		enrollment_status,
		initial_effective_date,
		enrollments
	} = data;

	// console.log("subplan", sub_plan, data);

	const backgroundImage = isVEB
		? VEBBenefitThumbnailMap[plan_name as keyof typeof VEBBenefitThumbnailMap]
		: CorePanhandlePlansName.includes(plan_name) &&
		  (enrollments as any[])[0].group_number === GROUP_NUMBER.BOP_PANHANDLE_FIRST_BANK
		? COREPFBBenefitThumbnailMap[plan_name as keyof typeof COREPFBBenefitThumbnailMap]
		: COREBenefitThumbnailMap[plan_name as keyof typeof COREBenefitThumbnailMap];
	return (
		<div
			key={index}
			className="border-separater"
			style={{
				borderBottom:
					index === (isVEB ? vebBenefits.length - 1 : coreBenefits.length - 1)
						? "1px solid rgba(0, 0, 0, 0.2)"
						: "none",
				paddingBottom: index === (isVEB ? vebBenefits.length - 1 : coreBenefits.length - 1) ? "16px" : "0"
			}}
		>
			<CoreVebCard
				backgroundImage={backgroundImage}
				plan_code={plan_code}
				plan_name={plan_name}
				base_plan_name={base_plan_name}
				sub_plan={sub_plan}
				enrollment_status={enrollment_status}
				total_premium={total_premium}
				effective_date={effective_date}
				benefit_end_date={benefit_end_date}
				termination_date={termination_date}
				enrollment_date={data.enrollment_date}
				initial_effective_date={initial_effective_date}
				enrollments={enrollments}
				coreTrueCount={coreTrueCount || {}}
				vebTrueCount={vebTrueCount || {}}
				coreDependents={coreDependents || {}}
				vebDependents={vebDependents || {}}
				vebRiderCount={vebRiderCount || {}}
				vebRiders={vebRiders || {}}
			/>
		</div>
	);
};

export default renderCard;
